const KEY = 'savvy_unit_progress';

const progressService = {
  save: (unitId, percent) => {
    try {
      const all = JSON.parse(localStorage.getItem(KEY) || '{}');
      all[unitId] = percent;
      localStorage.setItem(KEY, JSON.stringify(all));
    } catch (err) { console.error(err); }
  },
  get: (unitId) => {
    try { const all = JSON.parse(localStorage.getItem(KEY) || '{}'); return all[unitId] || 0; } catch { return 0; }
  },
  all: () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch { return {}; }
  }
};

export default progressService;